import { useMutation } from '@tanstack/react-query'
import { HttpStatusCode } from 'axios'

import type { TEnviarDocumentoParams, TEnviarDocumentoResponse } from '@/features/enviar-documentos/interfaces'
import { EnviarDocumentoDaPropostaService } from '@/features/enviar-documentos/services/enviar-documentos-proposta.service'
import { propostaKeys } from '@/features/proposta/utils'

export const useEnviarDocumentosProposta = (params: { numero: string; pessoaId: string }) => {
  return useMutation({
    mutationKey: propostaKeys.envioDocumentos(),
    mutationFn: async ({ arquivo, tipo, documentId }: TEnviarDocumentoParams): Promise<TEnviarDocumentoResponse> => {
      const response = await new EnviarDocumentoDaPropostaService().execute({
        arquivo,
        tipo,
        numeroDaProposta: params.numero,
        pessoaId: params.pessoaId,
      })
      return { sucesso: response.status === HttpStatusCode.Ok, documentId }
    },
  })
}
